<template>
  <base-cell
    v-slot:default="{hover}"
    @click="$emit('click', item)"
  >
    <base-avatar
      :size="44"
      :username="`${ item.first_name } ${ item.last_name }`"
    />
    <div class="d-flex justify-content-center flex-column position-relative group-cell__fullname">
      <base-text class="ml-4 group-cell__name">
        {{ (item.first_name || item.last_name ? `${item.first_name} ${item.last_name}` : item.external_id) | truncate(35) }}
      </base-text>
      <base-text
        class="ml-4 group-cell__email"
        size="s"
      >
        {{ item.email }}
      </base-text>
    </div>
    <base-button
      v-if="hover && group && !(group.is_supergroup || group.via_integration)"
      text
      small
      class="ml-auto"
      @click="$emit('delete', item)"
    >
      Remove
    </base-button>
  </base-cell>
</template>

<script>
export default {
  name: 'GroupDetailCell',
  props: {
    item: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    group() {
      if (!this.$store.state.groups.group) {
        return {};
      }
      return this.$store.state.groups.group;
    },
  },
};
</script>

<style lang="scss" scoped>
  .group-cell {
    min-height: 75px;
    background-color: inherit !important;

    &__name {
      min-width: 200px;
      margin-left: 1rem;
    }
    &__fullname{
    font-weight: 500;
    font-size: 14px;
    color: #1B1B1B;

    }
    &__email {
      font-family: 'SilkaLight';

    }
  }
</style>
